/* eslint-disable no-console */
import {
  all,
  call,
  delay,
  put,
  putResolve,
  race,
  take,
  takeLatest,
  select,
} from 'redux-saga/effects';
import { push } from 'react-router-redirect';
import { mapValues } from 'lodash';
import { Cookies } from 'react-cookie';
import getUsername from 'ui-common/src/utils/getUsername';
import { checkEnvironment, ecmLogin, initialiseEnv } from 'ui-common/src/lib/utils';
import SessionStorageService from 'ui-common/src/utils/SessionStorageService';
import { APP_CONSTANTS } from 'ui-common/src/constants';
import {
  APP_CONSTANTS_ACTION,
  APP_MESSAGES,
  appConstantsSuccess,
  appMessages,
  appMessagesSuccess,
  CONSOLIDATED_CONFIG_ACTION,
  GET_HEADER_MENU,
  GET_INITIAL_DATA_ACTION,
  GET_LEFTNAV_MODERN_EXP_GEN2_SUCCESS_ACTION,
  getCertsGen2Success,
  getCertsListGen2Success,
  getCertsMSconfigSuccess,
  getHeaderDetailsSuccess,
  getHomePageGen2Success,
  getHomepageKpisSuccess,
  getHomepageQuicklinksSuccess,
  getInitialDataSuccess,
  getIntitialDataAction,
  getIsMenuPinnedSuccess,
  getLeftNavModernGen2Success,
  getRequestGen2ConfigSuccess,
  loginFailedAction,
  loginInfoSuccess,
  loginRequestActionType,
  reloadPage,
  setCustomerInfo,
  setExternalClassificationFlag,
  setIDProofingFlag,
  setIsSaviEnabled,
  setOrchestrationFlag,
  setPendoInfo,
  setUpdateLanguageState,
  UPDATE_EMAIL_LANGUAGE,
  userDetailsActionType,
  userInfoAction,
  userModulesActionType,
  userModulesSuccessAction,
  getNativeSSHconfig,
  getPamJitAcct,
  setRequestsConfig,
} from 'ui-common/src/utils/LoginActions';
import { setSecureCookies } from 'ui-common/src/utils/common';
import { Logger } from '@saviynt/common';
import { fetchSessionTimeoutConfig } from 'ui-common/src/utils/sessionTiming';
import { LANGUAGE_CHANGE_STATE } from './constants';
import { IS_MENU_PINNED_KEY } from '../../../Layout/Layout';

import {
  FETCH_THEME_CONFIG_LIST,
  fetchThemeConfigListFailure,
  fetchThemeConfigListSuccess,
  GET_ACTIVE_FAVICON,
  GET_ACTIVE_HEADER_LOGO,
  GET_ACTIVE_LOGO,
  GET_ACTIVE_THEME,
  GET_ACTIVE_THEME_FAILURE,
  GET_ACTIVE_THEME_SUCCESS,
  getActiveFavIconFailure,
  getActiveFavIconSuccess,
  getActiveHeaderLogoFailure,
  getActiveHeaderLogoSuccess,
  getActiveLogoFailure,
  getActiveLogoSuccess,
  getActiveThemeFailure,
  getActiveThemeSuccess,
} from '../../AdminHome/redux/adminHome-actions';
import configJson from './domainConfig.json';
import { requestEcmVersionSaga } from '../Version/redux/version-saga';
import { FETCH_ECM_VERSION } from '../Version/redux/constants';
import { getHostUrl, loadImage } from '../../AdminHome/views/BrandingConfig/utils/helper';

const httpResponseCode = {
  // "Synthetic" response code outside of the RFC 9110 spec range to distinguish valid HTTP responses from `fetch`
  // calls that threw an error of some kind
  FETCH_ERROR: 600,
};
const CONFIGS_KEY = 'uiTrackConfig';
const featureFlagValues = {
  TRUE: 'true',
  FALSE: 'false',
  ENABLED: 'enabled',
  DISABLED: 'disabled',
};
const cookies = new Cookies();

function* userInfoSaga(action) {
  const { GATEWAY_API_URL } = checkEnvironment();
  const response = yield call(fetch, `${GATEWAY_API_URL}/api/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // TENANT_ID: 'TEST',
    },
    body: JSON.stringify(action.payload),
  });
  if (response && response.status === 200) {
    const json = yield call([response, response.json]);
    if (json) {
      setSecureCookies('token_type', json.tokenType);
      sessionStorage.setItem('micro_app', 'requestMiniApp');
      localStorage.setItem('micro_app', 'requestMiniApp');
      setSecureCookies('access_token', json.accessToken);
      // Pre-populate the Redux store with the username from the login
      // response so that getUsername() can resolve it synchronously in
      // fetchInitialDataSaga (which runs before /api/user/details returns).
      yield put(userInfoAction({ username: json.username }));
      // get All the initial data i.e UserDetails, HeaderDetails, userModules, Themes..
      // Send true so that messages is not loaded in this API.
      yield put(getIntitialDataAction('', true));
      // ecmLoginData();
      yield putResolve({ type: 'loginSuccessAction', json });
      const refreshTokenResponse = yield call(fetch, `${GATEWAY_API_URL}/api/auth/refresh-token`, {
        method: 'POST',
        headers: {
          Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
          // TENANT_ID: 'TEST',
        },
      });
      if (refreshTokenResponse && refreshTokenResponse.status === 200) {
        const refreshTokenJson = yield call([refreshTokenResponse, refreshTokenResponse.json]);
        if (refreshTokenJson) {
          setSecureCookies('refresh_token', refreshTokenJson.refreshToken);
        }
      }
    }
    if (action.destinationUrl) {
      push(action.destinationUrl);
    }
  } else if (response && response.status === 401) {
    yield put(loginFailedAction());
  }
}

function* fetchUserDetails() {
  const { GATEWAY_API_URL } = checkEnvironment();

  const userDetails = yield call(fetch, `${GATEWAY_API_URL}/api/user/details`, {
    method: 'POST',
    headers: {
      ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
        Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
      }),
      // TENANT_ID: 'TEST',
    },
  });
  if (userDetails && userDetails.status === 200) {
    const userjson = yield call([userDetails, userDetails.json]);

    yield put(userInfoAction(userjson));

    userjson.userSavRoleMap.locale = userjson.userSavRoleMap.locale ?? 'en';
    yield put(
      loginInfoSuccess({ ...userjson.userSavRoleMap, showLoginSnack: !cookies.get('userKey') })
    );
    setSecureCookies('first_name', userjson.firstname);
    setSecureCookies('userKey', userjson.id);
  }
}

function* userModulesSaga() {
  const { GATEWAY_API_URL, BLOCKED_URLS } = checkEnvironment();
  if (!GATEWAY_API_URL) return;
  if (!cookies.get('token_type')) return;
  let url = `${GATEWAY_API_URL}/api/auth/featuresMap`;
  let method = 'POST';
  const username = yield call(getUsername.async);
  if (BLOCKED_URLS) {
    url = `${GATEWAY_API_URL}/api/userms/auth/v2/features/${username}`;
    method = 'GET';
  }
  const response = yield call(fetch, url, {
    method,
    headers: {
      ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
        Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
      }),
      'X-NOLOADER': true,
      // TENANT_ID: 'TEST',
    },
  });
  if (response && response.status === 200) {
    const json = yield call([response, response.json]);
    if (json) {
      yield put(userModulesSuccessAction(json));
    }
  }
}

function parseConfigValues(configData) {
  const { FALSE, TRUE, ENABLED, DISABLED } = featureFlagValues;

  // Remove any occurrence of $domain_name with hostname
  const constValues = mapValues(configData, (value) => {
    if (typeof value === 'string') {
      const lowerValue = value.toLocaleLowerCase();
      if ([FALSE, TRUE, ENABLED, DISABLED].includes(lowerValue)) {
        return [TRUE, ENABLED].includes(lowerValue);
      }
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return value.replace('https://$domain', localStorage.getItem('localDomain')); // taking care of localhost for development.
      }
      return value.replace('$domain', window.location.host); // $domain in value string will be replaced.
    }
    return value; // if value is object , it wil be unmodified
  });
  return constValues;
}

function* fetchAppConstants(action) {
  try {
    // const query = useQuery();
    // const { GATEWAY_API_URL } = checkEnvironment();
    const { domain, locale } = action.payload;
    let url = '';
    if (window.DEMO_MODE) {
      url = `http://${window.location.hostname}:3100/api/appConstants?domain=${domain}`;
    } else if (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    ) {
      if (localStorage.getItem('localDomain') !== null) {
        url = `${localStorage.getItem('localDomain')}/ECMv6/api/config/ui-track?v=${Math.random(
          100
        )}`;
      } else url = `${domain}/ECMv6/api/config/ui-track`;
    } else {
      url = `/ECMv6/api/config/ui-track?v=${Math.random(100)}`; // url should be from config. not based on GATEWAY URL
    }
    const response = yield call(fetch, url, {
      method: 'GET',
      headers: {},
    });

    if (response && response.status === 200) {
      const serverJson = yield call([response, response.json]);
      const json = serverJson;
      let mergedConfig = {};
      if (
        serverJson &&
        serverJson.propertySources &&
        serverJson.propertySources[0] &&
        serverJson.propertySources[0].source
      ) {
        mergedConfig = {
          ...configJson.propertySources[0].source,
          ...serverJson.propertySources[0].source,
        };
      } else {
        mergedConfig = configJson.propertySources[0].source;
      }
      if (json.propertySources) {
        const constValues = parseConfigValues(mergedConfig);
        SessionStorageService.set(APP_CONSTANTS, { [domain]: constValues });
        initialiseEnv(constValues);
        yield put(appConstantsSuccess(constValues));
        if (constValues.GATEWAY_API_URL) {
          yield put(appMessages(locale || 'en', constValues.GATEWAY_API_URL));
        }
      }
    }
  } catch (error) {
    Logger.error('Error---', error);
  }
}

function* fetchAppMessages(action) {
  try {
    let url = null;
    const lang = action.payload.locale;
    if (window.DEMO_MODE) {
      url = `http://${window.location.hostname}:3100/api/messages?locale=${
        lang && lang !== 'undefined' ? lang : 'en'
      }`;
    } else {
      url = `${action.payload.gateway}/api/idw/messageProperties/retrieveMessages?locale=${
        lang && lang !== 'undefined' ? lang : 'en'
      }`;
    }

    const response = yield call(fetch, url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-NOLOADER': true,
        ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
          Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
        }),
      },
    });
    if (response && response.status === 200) {
      const json = yield call([response, response.json]);
      const messagesObj = {};
      json.forEach((j) => {
        messagesObj[j.messageKey] = j.messageValue;
      });
      yield put(appMessagesSuccess(messagesObj));
    }
  } catch (error) {
    Logger.error('Error---', error);
  }
}

function* loginInfoSaga(action) {
  const { GATEWAY_API_URL } = checkEnvironment();
  if (!GATEWAY_API_URL) return;
  const response = yield call(fetch, `${GATEWAY_API_URL}/api/user/info`, {
    method: 'GET',
    headers: {
      ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
        Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
      }),
    },
  });
  if (response && response.status === 200) {
    const loginInfoJson = yield call([response, response.json]);
    if (loginInfoJson.lastLoginTime) {
      yield put(loginInfoSuccess(loginInfoJson));
    }
  }
}

function* fetchHeaderMenu() {
  const { GATEWAY_API_URL } = checkEnvironment();
  try {
    const url = `${GATEWAY_API_URL}/api/idw/config/global?featureType=HEADERSPREFERENCES`;

    const response = yield call(fetch, url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
          Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
        }),
      },
    });
    if (response && response.status === 200) {
      const json = yield call([response, response.json]);
      yield put(getHeaderDetailsSuccess(json));
    }
  } catch (error) {
    Logger.error('Error---', error);
  }
}

function* updateEmailAndLanguage(action) {
  try {
    const { GATEWAY_API_URL, ECM_URL } = checkEnvironment();
    const response = yield call(fetch, `${GATEWAY_API_URL}/api/idw/users/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
          Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}
        `,
        }),
        'X-NOLOADER': action.noLoader,
      },
      body: JSON.stringify(action.payload),
    });
    const langResp = yield call(
      fetch,
      `${ECM_URL}/users/updateLanguage?lang=${action.payload.locale}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
            Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
          }),
          'X-NOLOADER': action.noLoader,
        },
      }
    );
    if (response && response.status === 200) {
      // do something if needed
    }

    if (langResp && langResp.status === 200) {
      yield put(setUpdateLanguageState(LANGUAGE_CHANGE_STATE.SUCCESS));
    } else {
      yield put(setUpdateLanguageState(LANGUAGE_CHANGE_STATE.FAILED));
    }
    // Reload the page to update ECM gsp pages render the updated language
    yield put(reloadPage());
  } catch (error) {
    Logger.error(error);
    yield put(setUpdateLanguageState(LANGUAGE_CHANGE_STATE.FAILED));
  }
}

function* fetchThemeConfigSaga() {
  // Wait for the leftNavGen2 flag from the config API before deciding whether to fetch theme.json.
  // If redux already has the value (e.g., from fetchInitialDataSaga), use it immediately.
  // Otherwise, race between the config success action and a timeout fallback.
  let leftNavGen2 = yield select((state) => state.user.leftNavGen2);

  if (leftNavGen2 === null) {
    const { configResolved } = yield race({
      configResolved: take(GET_LEFTNAV_MODERN_EXP_GEN2_SUCCESS_ACTION),
      timeout: delay(5000),
    });

    leftNavGen2 = configResolved?.payload?.configData || localStorage.getItem('leftNavGen2');
  }

  // Skip legacy theme.json fetch when gen2 left nav is enabled — gen2 uses /navigation/theme instead.
  // Dispatch default theme so CSS variables still get written to the DOM.
  if (leftNavGen2 === '1') {
    yield put(fetchThemeConfigListSuccess({}));
    return;
  }

  try {
    const { GATEWAY_API_URL } = checkEnvironment();
    const url = `${GATEWAY_API_URL}/api/idw/res/file?path=/app/usr/theme.json`;

    const response = yield call(fetch, url, {
      method: 'GET',
      headers: {
        ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
          Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
        }),
        'Content-Type': 'application/json',
      },
    });
    if (response && response.status === 200) {
      const json = yield call([response, response.json]);
      if (json) {
        yield put(fetchThemeConfigListSuccess(json));
        if (Object.keys(json).length > 0) {
          localStorage.setItem(
            'savedTheme',
            JSON.stringify({
              ...json,
            })
          );
        }
      }
    } else {
      yield put(fetchThemeConfigListFailure());
    }
  } catch (error) {
    Logger.error(error);
    yield put(fetchThemeConfigListFailure());
  }
}

function* getActiveThemeSaga() {
  const URL = getHostUrl();
  if (URL === 'localhost' || URL) {
    try {
      const url = `${URL}/navigation/theme`;
      const response = yield call(fetch, url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-NOLOADER': true,
          'X-NOERRORMODAL': true,
          ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
            Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
          }),
        },
      });
      if (response && response.status === 200) {
        const json = yield call([response, response.json]);
        if (!json?.error) {
          const resStyles = JSON.parse(json?.styles);

          // Convert styles field to JavaScript object
          if (json?.styles) {
            json.styles = resStyles;
          }
          yield put({ type: GET_ACTIVE_THEME_SUCCESS, response: json });
        } else {
          yield put({ type: GET_ACTIVE_THEME_FAILURE, error: json });
        }
      } else {
        const jsonString = yield call([response, response.text]);
        yield put({ type: GET_ACTIVE_THEME_FAILURE, error: jsonString });
      }
    } catch (error) {
      yield put({ type: GET_ACTIVE_THEME_FAILURE });
    }
  }
}

function* getActiveLogoSaga() {
  const URL = getHostUrl();
  if (URL === 'localhost' || URL) {
    try {
      const url = `${URL}/navigation/logos/logo`;
      const response = yield call(fetch, url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-NOLOADER': true,
          'X-NOERRORMODAL': true,
          ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
            Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
          }),
        },
      });

      if (response && response.status === 200) {
        try {
          const json = yield call([response, response.blob]);
          if (json && json?.type !== 'text/json' && json?.type !== 'application/json') {
            yield put(getActiveLogoSuccess(json));
          } else {
            yield put(getActiveLogoFailure(json));
          }
        } catch (e) {
          yield put(getActiveLogoFailure(e));
        }
      } else {
        yield put(getActiveLogoFailure(response));
      }
    } catch (error) {
      yield put(getActiveLogoFailure(error));
    }
  }
}

// Logo cache to prevent duplicate API calls
const logoCache = new Map();
function* getActiveHeaderLogoSaga() {
  const URL = getHostUrl();
  if (URL === 'localhost' || URL) {
    try {
      // Get theme from Redux state instead of DOM
      const theme = yield select((state) => state.theme?.currentTheme || 'light');

      let url = `${URL}/navigation/logos/headerlogo`;
      if (theme === 'dark') {
        url = `${URL}/navigation/logos/logo`;
      }

      // Check cache first
      const cacheKey = `${theme}-header-logo`;
      if (logoCache.has(cacheKey)) {
        yield put(getActiveHeaderLogoSuccess(logoCache.get(cacheKey)));
        return;
      }

      const response = yield call(fetch, url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-NOLOADER': true,
          'X-NOERRORMODAL': true,
          ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
            Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
          }),
        },
      });

      if (response && response.status === 200) {
        try {
          const json = yield call([response, response.blob]);
          if (json && json?.type !== 'text/json' && json?.type !== 'application/json') {
            // Cache the logo
            const theme = yield select((state) => state.theme?.currentTheme || 'light');
            const cacheKey = `${theme}-header-logo`;
            logoCache.set(cacheKey, json);
            yield put(getActiveHeaderLogoSuccess(json));
          } else {
            yield put(getActiveHeaderLogoFailure(json));
          }
        } catch (e) {
          yield put(getActiveHeaderLogoFailure(e));
        }
      } else {
        yield put(getActiveHeaderLogoFailure(response));
      }
    } catch (e) {
      yield put(getActiveHeaderLogoFailure(e));
    }
  }
}

function* getActiveFavIconSaga() {
  const URL = getHostUrl();
  if (URL === 'localhost' || URL) {
    try {
      const url = `${URL}/navigation/favicon`;
      const response = yield call(fetch, url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-NOLOADER': true,
          'X-NOERRORMODAL': true,
          ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
            Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
          }),
        },
      });

      if (response && response.status === 200) {
        try {
          const json = yield call([response, response.blob]);
          if (json && json?.type !== 'text/json' && json?.type !== 'application/json') {
            yield put(getActiveFavIconSuccess(loadImage(json)));
          } else {
            yield put(getActiveFavIconFailure(json));
          }
        } catch (e) {
          yield put(getActiveFavIconFailure(e));
        }
      } else {
        yield put(getActiveFavIconFailure(response));
      }
    } catch (e) {
      yield put(getActiveFavIconFailure(e));
    }
  }
}

// TODO This was a quick fix for FON-14544. The design of this function should be improved b/c it assumes `fn` is
// `fetch`. Should make return type to s/t like `{ result: ... } | { error: Error }`, or rename it `fetchCall` and
// remove the `fn` parameter.
function* safeCall(fn, ...args) {
  try {
    return yield call(fn, ...args);
  } catch (error) {
    return { status: httpResponseCode.FETCH_ERROR, error };
  }
}

function* fetchInitialDataSaga(action) {
  // Shadow `call` with safeCall for the remaining fetch calls so individual
  // endpoint failures don't abort the entire initialization batch.
  const call = safeCall; // eslint-disable-line no-shadow
  const { GATEWAY_API_URL, BLOCKED_URLS } = checkEnvironment();

  if (!GATEWAY_API_URL || !cookies.get('token_type')) return;

  try {
    // Read username from Redux store synchronously.
    // During login: login saga puts username in store, then dispatches this
    // action — username should be available via getUsername().
    // On page reload: store is empty, features is deferred to after user/details.
    const username = getUsername();

    let userModulesUrl = `${GATEWAY_API_URL}/api/auth/featuresMap`;
    let userModulesMethod = 'POST';
    let deferUserModules = false;
    if (BLOCKED_URLS) {
      if (username) {
        userModulesUrl = `${GATEWAY_API_URL}/api/userms/auth/v2/features/${username}`;
        userModulesMethod = 'GET';
      } else {
        // Username not in store yet. Fetch features after user/details
        // returns the username. Skip it from the parallel batch.
        deferUserModules = true;
      }
    }

    // fetchSessionTimeoutConfig runs in parallel with initial data fetches — it bootstraps
    // Redux with server-provided timeout values but nothing below depends on its result.
    const [
      ,
      userDetails,
      headersResponse,
      userModulesResponse,
      gen2ActiveTheme,
      gen2ActiveLogo,
      gen2ActiveHeaderLogo,
      globalConfigApiResponse,
    ] = yield all([
      call(fetchSessionTimeoutConfig),
      call(fetch, `${GATEWAY_API_URL}/api/user/details`, {
        method: 'POST',
        headers: {
          ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
            Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
          }),
          'X-NOLOADER': true,
          // TENANT_ID: 'TEST',
        },
      }),
      call(fetch, `${GATEWAY_API_URL}/api/idw/config/global?featureType=HEADERSPREFERENCES`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
            Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
          }),
          'X-NOLOADER': true,
        },
      }),
      deferUserModules
        ? call(() => null)
        : call(fetch, userModulesUrl, {
          method: userModulesMethod,
          headers: {
            ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
              Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
            }),
            'X-NOLOADER': true,
          },
        }),
      getHostUrl() &&
        call(fetch, `${getHostUrl()}/navigation/theme`, {
          method: 'GET',
          redirect: 'error',
          headers: {
            ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
              Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
            }),
            'Content-Type': 'application/json',
            'X-NOLOADER': true,
            'X-NOERRORMODAL': true,
          },
        }),
      getHostUrl() &&
        call(fetch, `${getHostUrl()}/navigation/logos/logo`, {
          method: 'GET',
          redirect: 'error',
          headers: {
            ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
              Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
            }),
            'Content-Type': 'application/json',
            'X-NOLOADER': true,
            'X-NOERRORMODAL': true,
          },
        }),
      getHostUrl() &&
        call(fetch, `${getHostUrl()}/navigation/logos/headerlogo`, {
          method: 'GET',
          redirect: 'error',
          headers: {
            ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
              Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
            }),
            'Content-Type': 'application/json',
            'X-NOLOADER': true,
            'X-NOERRORMODAL': true,
          },
        }),
      call(fetch, `${GATEWAY_API_URL}/api/idw/config/byListName/uiTrackConfig`, {
        method: 'GET',
        headers: {
          ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
            Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
          }),
          'Content-Type': 'application/json',
          'X-NOLOADER': true,
        },
      }),
    ]);
    if (!action.isLogin) {
      let url = null;
      const lang = action.locale;
      if (window.DEMO_MODE) {
        url = `http://${window.location.hostname}:3100/api/messages?locale=${
          lang && lang !== 'undefined' ? lang : 'en'
        }`;
      } else {
        url = `${GATEWAY_API_URL}/api/idw/messageProperties/retrieveMessages?locale=${
          lang && lang !== 'undefined' ? lang : 'en'
        }`;
      }
      const appMessagesResponse = yield call(fetch, url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-NOLOADER': true,
        },
      });
      try {
        if (appMessagesResponse && appMessagesResponse.status === 200) {
          const json = yield call([appMessagesResponse, appMessagesResponse.json]);
          const messagesObj = {};
          json.forEach((j) => {
            messagesObj[j.messageKey] = j.messageValue;
          });
          yield put(appMessagesSuccess(messagesObj));
        }
      } catch (error) {
        Logger.error(error);
      }
    }
    try {
      if (userDetails && userDetails.status === 200) {
        const userjson = yield call([userDetails, userDetails.json]);
        yield put(userInfoAction(userjson));
        userjson.userSavRoleMap.locale = userjson.userSavRoleMap.locale ?? 'en';
        yield put(
          loginInfoSuccess({ ...userjson.userSavRoleMap, showLoginSnack: !cookies.get('userKey') })
        );
        setSecureCookies('first_name', userjson.firstname);
        setSecureCookies('userKey', userjson.id);

        // If features call was deferred (page reload — username wasn't in store),
        // fetch it now that we have the username from user/details.
        if (deferUserModules && userjson.username) {
          try {
            const deferredUrl = `${GATEWAY_API_URL}/api/userms/auth/v2/features/${userjson.username}`;
            const deferredResponse = yield call(fetch, deferredUrl, {
              method: 'GET',
              headers: {
                ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
                  Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
                }),
                'X-NOLOADER': true,
              },
            });
            if (deferredResponse && deferredResponse.status === 200) {
              const json = yield call([deferredResponse, deferredResponse.json]);
              if (json) yield put(userModulesSuccessAction(json));
            }
          } catch (error) {
            Logger.error(error);
          }
        }
      }
    } catch (error) {
      Logger.error(error);
    }

    try {
      if (headersResponse && headersResponse.status === 200) {
        const json = yield call([headersResponse, headersResponse.json]);
        yield put(getHeaderDetailsSuccess(json));
      }
    } catch (error) {
      Logger.error(error);
    }

    try {
      if (userModulesResponse && userModulesResponse.status === 200) {
        const json = yield call([userModulesResponse, userModulesResponse.json]);
        if (json) {
          yield put(userModulesSuccessAction(json));
        }
      }
    } catch (error) {
      Logger.error(error);
    }

    if (gen2ActiveTheme && gen2ActiveTheme.status === 200) {
      try {
        const json = yield call([gen2ActiveTheme, gen2ActiveTheme.text]);
        const res = JSON.parse(json);
        if (!res?.error) {
          const resStyles = JSON.parse(res?.styles);

          // Convert styles field to JavaScript object
          if (res?.styles) {
            res.styles = resStyles;
          }
          yield put(getActiveThemeSuccess(res));
        } else {
          yield put(getActiveThemeFailure());
        }
      } catch (e) {
        yield put(getActiveThemeFailure());
      }
    } else {
      // Unhandled error, assuming login session timeout as when 302 is returned
      const isActiveThemeUnauthorized = gen2ActiveTheme.status === httpResponseCode.FETCH_ERROR;
      yield put(getActiveThemeFailure({ isActiveThemeUnauthorized }));
      ecmLogin();
    }

    if (gen2ActiveLogo && gen2ActiveLogo.status === 200) {
      try {
        const json = yield call([gen2ActiveLogo, gen2ActiveLogo.blob]);
        if (json && json?.type !== 'text/json') {
          yield put(getActiveLogoSuccess(json));
        } else {
          yield put(getActiveLogoFailure(json));
        }
      } catch (e) {
        yield put(getActiveLogoFailure(e));
      }
    } else {
      yield put(getActiveLogoFailure(gen2ActiveLogo));
    }

    if (gen2ActiveHeaderLogo && gen2ActiveHeaderLogo.status === 200) {
      try {
        const json = yield call([gen2ActiveHeaderLogo, gen2ActiveHeaderLogo.blob]);
        if (json && json?.type !== 'text/json') {
          yield put(getActiveHeaderLogoSuccess(json));
        } else {
          yield put(getActiveHeaderLogoFailure(json));
        }
      } catch (e) {
        yield put(getActiveHeaderLogoFailure(e));
      }
    } else {
      yield put(getActiveHeaderLogoFailure(gen2ActiveLogo));
    }

    try {
      localStorage.removeItem(CONFIGS_KEY);
      if (globalConfigApiResponse && globalConfigApiResponse?.status === 200) {
        const json = yield call([globalConfigApiResponse, globalConfigApiResponse?.json]);
        const configs = json.reduce((acc, data) => ({ ...acc, [data.key]: data.configData }), {});

        // Extract certs flags from uiTrackConfig instead of separate API calls
        if (configs.NEW_CERT_UX) {
          cookies.set('certGen2Flag', configs.NEW_CERT_UX, { path: '/' });
          localStorage.setItem('certGen2Flag', configs.NEW_CERT_UX);
          yield put(getCertsGen2Success({ configData: configs.NEW_CERT_UX }));
          delete configs.NEW_CERT_UX;
        }
        if (configs.NEW_CERT_LIST_UX) {
          cookies.set('certListGen2Flag', configs.NEW_CERT_LIST_UX, { path: '/' });
          localStorage.setItem('certListGen2Flag', configs.NEW_CERT_LIST_UX);
          yield put(getCertsListGen2Success({ configData: configs.NEW_CERT_LIST_UX }));
          delete configs.NEW_CERT_LIST_UX;
        }
        if (configs.NEW_CERT_MS_UX) {
          cookies.set('certsMSconfig', configs.NEW_CERT_MS_UX, { path: '/' });
          localStorage.setItem('certsMSconfig', configs.NEW_CERT_MS_UX);
          yield put(getCertsMSconfigSuccess({ configData: configs.NEW_CERT_MS_UX }));
          delete configs.NEW_CERT_MS_UX;
        }
        const possibleValues = json.reduce(
          (acc, data) => ({ ...acc, [data.key]: data.possibleValues }),
          {}
        );

        if (configs.GEN2_ENABLE_LEFT_NAVIGATION) {
          cookies.set('leftNavGen2', configs.GEN2_ENABLE_LEFT_NAVIGATION, { path: '/' });
          localStorage.setItem('leftNavGen2', configs.GEN2_ENABLE_LEFT_NAVIGATION);
          yield put(
            getLeftNavModernGen2Success({ configData: configs.GEN2_ENABLE_LEFT_NAVIGATION })
          );
          delete configs.GEN2_ENABLE_LEFT_NAVIGATION;
        }

        let isMenuPinnedBrowserPref = localStorage.getItem(IS_MENU_PINNED_KEY);
        if (isMenuPinnedBrowserPref === null && configs.EXPAND_NAVIGATION_LOGIN) {
          isMenuPinnedBrowserPref = configs.EXPAND_NAVIGATION_LOGIN === '1' ? 'true' : 'false';
        }
        if (isMenuPinnedBrowserPref) {
          const isMenuPinned = JSON.parse(isMenuPinnedBrowserPref);
          yield put(getIsMenuPinnedSuccess({ isMenuPinned }));
          delete configs.EXPAND_NAVIGATION_LOGIN;
        }

        if (configs.ENABLE_SAVI_SERVICE_ACCOUNT) {
          yield put(setIsSaviEnabled(configs.ENABLE_SAVI_SERVICE_ACCOUNT === '1'));
          delete configs.ENABLE_SAVI_SERVICE_ACCOUNT;
        }

        if (configs.GEN2_ENABLE_HOME_PAGE) {
          yield put(getHomePageGen2Success({ configData: configs.GEN2_ENABLE_HOME_PAGE }));
          delete configs.GEN2_ENABLE_HOME_PAGE;
        }

        if (configs.ENABLE_NEW_ARS_UI) {
          yield put(getRequestGen2ConfigSuccess({ configData: configs.ENABLE_NEW_ARS_UI }));
          delete configs.ENABLE_NEW_ARS_UI;
        }

        // Populate Redux with Requests package Global Config Values
        yield put(
          setRequestsConfig({
            SHOW_COLUMNS_ON_REQUEST_APPROVAL: configs.SHOW_COLUMNS_ON_REQUEST_APPROVAL || null,
            SHOW_COLUMNS_ON_REQUEST_HISTORY: configs.SHOW_COLUMNS_ON_REQUEST_HISTORY || null,
            ENABLE_BULK_ACCEPT_IN_APPROVAL: configs.ENABLE_BULK_ACCEPT_IN_APPROVAL || null,
            APPROVAL_COMMENTS_REQ: configs.APPROVAL_COMMENTS_REQ || null,
            ARSAPPROVECOMMENTS: configs.ARSAPPROVECOMMENTS || null,
            ARSREJECTCOMMENTS: configs.ARSREJECTCOMMENTS || null,
            ENABLE_BULK_APPROVAL_COMMENTS: configs.ENABLE_BULK_APPROVAL_COMMENTS || null,
            GUARDRAIL_LIMIT_FOR_COMMENTS: configs.GUARDRAIL_LIMIT_FOR_COMMENTS || null,
            ENABLE_REQ_APPROVAL_ASYNC: configs.ENABLE_REQ_APPROVAL_ASYNC || null,
          })
        );

        // Populate Redux with Native SSH Global Config Values
        if (configs.ENABLE_NATIVE_SSH && configs.ENABLE_GENERATE_NATIVE_SSH_TOKEN) {
          yield put(
            getNativeSSHconfig(configs.ENABLE_NATIVE_SSH, configs.ENABLE_GENERATE_NATIVE_SSH_TOKEN)
          );
          delete configs.ENABLE_NATIVE_SSH;
          delete configs.ENABLE_GENERATE_NATIVE_SSH_TOKEN;
        }

        if (configs.ALLOW_JIT_ACC_CREATION) {
          cookies.set('pamJitAcct', configs.ALLOW_JIT_ACC_CREATION, { path: '/' });
          localStorage.setItem('pamJitAcct', configs.ALLOW_JIT_ACC_CREATION);
          yield put(getPamJitAcct({ configData: configs.ALLOW_JIT_ACC_CREATION }));
          delete configs.ALLOW_JIT_ACC_CREATION;
        }

        yield getExternalClassificationFlag(configs);
        yield getIDProofingFlag(configs);
        yield getOrchestrationFlag(configs);
        yield processHomePageConfigs(configs, possibleValues);
        yield processCustomerConfig(configs);
        yield processPendoConfig(configs);

        localStorage.setItem(CONFIGS_KEY, JSON.stringify(configs));
      }
    } catch (error) {
      Logger.error(error);
    }

    // Fetch legacy theme.json only when gen2 left nav is not enabled.
    // Deferred until after globalConfigApiResponse so leftNavGen2 is known from the API.
    const isLeftNavGen2 = localStorage.getItem('leftNavGen2') === '1';
    if (isLeftNavGen2) {
      // No legacy theme.json fetch needed — dispatch defaults so CSS variables still get set.
      yield put(fetchThemeConfigListSuccess({}));
    } else {
      try {
        const themeResponse = yield call(
          fetch,
          `${GATEWAY_API_URL}/api/idw/res/file?path=/app/usr/theme.json`,
          {
            method: 'GET',
            headers: {
              ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
                Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
              }),
              'Content-Type': 'application/json',
              'X-NOLOADER': true,
            },
          }
        );
        if (themeResponse && themeResponse.status === 200) {
          const json = yield call([themeResponse, themeResponse.json]);
          if (json) {
            yield put(fetchThemeConfigListSuccess(json));
            if (Object.keys(json).length > 0) {
              localStorage.setItem('savedTheme', JSON.stringify({ ...json }));
            }
          }
        } else {
          yield put(fetchThemeConfigListFailure());
        }
      } catch (e) {
        yield put(fetchThemeConfigListFailure());
      }
    }

    yield put(getInitialDataSuccess());
  } catch (e) {
    // exception
    yield put(getInitialDataSuccess());
    // yield put(requestImportantActionsListFailure(finalResponseArray));
  }
}

function* processPendoConfig(configs) {
  if (configs.PENDO_API_KEY) {
    const pendoInfo = {
      apiKey: configs.PENDO_API_KEY,
    };
    yield put(setPendoInfo(pendoInfo));
    delete configs.PENDO_API_KEY;
  }
}

function* getExternalClassificationFlag(configs) {
  yield put(
    setExternalClassificationFlag({
      externalClassification: configs.ENABLE_EXTERNAL_CLASSIFICATION,
    })
  );
  delete configs.ENABLE_EXTERNAL_CLASSIFICATION;
}

function* getIDProofingFlag(configs) {
  yield put(setIDProofingFlag(configs.ENABLE_EXTERNAL_ID_PROOFING === '1'));
  delete configs.ENABLE_EXTERNAL_ID_PROOFING;
}

function* getOrchestrationFlag(configs) {
  yield put(setOrchestrationFlag(configs.ENABLE_ORCHESTRATION === '1'));
  delete configs.ENABLE_ORCHESTRATION;
}

function* processHomePageConfigs(configs, possibleValues) {
  if (configs.HOMEPAGE_QUICKLINKS !== undefined) {
    const value =
      configs.HOMEPAGE_QUICKLINKS === ''
        ? []
        : Object.keys(JSON.parse(configs.HOMEPAGE_QUICKLINKS));
    // possible values are wrapped in '###'
    const possibleValuesArray = Object.keys(
      JSON.parse(possibleValues.HOMEPAGE_QUICKLINKS.slice(3, -3))
    );

    yield put(getHomepageQuicklinksSuccess(value, possibleValuesArray));
    delete configs.HOMEPAGE_QUICKLINKS;
  } else {
    yield put(getHomepageQuicklinksSuccess('unauthorized'));
  }

  if (configs.HOMEPAGE_KPIS) {
    const value =
      configs.HOMEPAGE_KPIS === '' ? [] : Object.keys(JSON.parse(configs.HOMEPAGE_KPIS));
    yield put(getHomepageKpisSuccess(value));
    delete configs.HOMEPAGE_KPIS;
  } else {
    yield put(getHomepageKpisSuccess('unauthorized'));
  }
}

function* processCustomerConfig(configs) {
  if (configs.CUSTOMER_ENVIRONMENT || configs.CUSTOMER_NAME) {
    const customerInfo = {
      environment: configs.CUSTOMER_ENVIRONMENT,
      customerName: configs.CUSTOMER_NAME,
    };
    yield put(setCustomerInfo(customerInfo));
    delete configs.CUSTOMER_ENVIRONMENT;
    delete configs.CUSTOMER_NAME;
  }
}

function* getConsolidatedConfigSaga() {
  localStorage.removeItem(CONFIGS_KEY);
  try {
    const { GATEWAY_API_URL } = checkEnvironment();

    const response = yield call(
      fetch,
      `${GATEWAY_API_URL}/api/idw/config/byListName/uiTrackConfig`,
      {
        method: 'GET',
        headers: {
          ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN || {
            Authorization: `${cookies.get('token_type')} ${cookies.get('access_token')}`,
          }),
          'Content-Type': 'application/json',
          'X-NOLOADER': true,
        },
      }
    );
    if (response?.status === 200) {
      const json = yield call([response, response?.json]);
      const configs = json.reduce((acc, data) => ({ ...acc, [data.key]: data.configData }), {});
      const possibleValues = json.reduce(
        (acc, data) => ({ ...acc, [data.key]: data.possibleValues }),
        {}
      );

      Logger.log('trying to get customer environment', configs.CUSTOMER_ENVIRONMENT);
      yield processCustomerConfig(configs);
      yield processPendoConfig(configs);
      yield processHomePageConfigs(configs, possibleValues);

      // Extract certs flags from uiTrackConfig
      if (configs.NEW_CERT_UX) {
        cookies.set('certGen2Flag', configs.NEW_CERT_UX, { path: '/' });
        localStorage.setItem('certGen2Flag', configs.NEW_CERT_UX);
        yield put(getCertsGen2Success({ configData: configs.NEW_CERT_UX }));
        delete configs.NEW_CERT_UX;
      }
      if (configs.NEW_CERT_LIST_UX) {
        cookies.set('certListGen2Flag', configs.NEW_CERT_LIST_UX, { path: '/' });
        localStorage.setItem('certListGen2Flag', configs.NEW_CERT_LIST_UX);
        yield put(getCertsListGen2Success({ configData: configs.NEW_CERT_LIST_UX }));
        delete configs.NEW_CERT_LIST_UX;
      }
      if (configs.NEW_CERT_MS_UX) {
        cookies.set('certsMSconfig', configs.NEW_CERT_MS_UX, { path: '/' });
        localStorage.setItem('certsMSconfig', configs.NEW_CERT_MS_UX);
        yield put(getCertsMSconfigSuccess({ configData: configs.NEW_CERT_MS_UX }));
        delete configs.NEW_CERT_MS_UX;
      }

      localStorage.setItem(CONFIGS_KEY, JSON.stringify(configs));

      yield getHomePageGen2Saga();
      yield getLeftNavModernGen2();
      yield getExpandLeftNav();
    } else {
      Logger.error('getConsolidatedConfigSaga failed');
    }
  } catch (error) {
    Logger.error(error);
  }
}

function* getHomePageGen2Saga() {
  try {
    const val = JSON.parse(localStorage.getItem(CONFIGS_KEY)).GEN2_ENABLE_HOME_PAGE;
    if (val) {
      yield put(getHomePageGen2Success({ configData: val }));
    } else {
      Logger.error('GEN2_ENABLE_HOME_PAGE failed');
    }
  } catch (error) {
    Logger.error(error);
  }
}

function* getLeftNavModernGen2() {
  try {
    const val = JSON.parse(localStorage.getItem(CONFIGS_KEY)).GEN2_ENABLE_LEFT_NAVIGATION;
    if (val) {
      yield put(getLeftNavModernGen2Success({ configData: val }));
      localStorage.setItem('leftNavGen2', val);
    } else {
      Logger.error('GEN2_ENABLE_LEFT_NAVIGATION failed');
    }
  } catch (error) {
    Logger.error(error);
  }
}

function* getExpandLeftNav() {
  try {
    let isMenuPinnedBrowserPref = localStorage.getItem(IS_MENU_PINNED_KEY);
    if (isMenuPinnedBrowserPref === null) {
      const val = JSON.parse(localStorage.getItem(CONFIGS_KEY)).EXPAND_NAVIGATION_LOGIN;
      if (val) {
        isMenuPinnedBrowserPref = val === '1' ? 'true' : 'false';
      }
    }
    if (isMenuPinnedBrowserPref) {
      const isMenuPinned = JSON.parse(isMenuPinnedBrowserPref);
      yield put(getIsMenuPinnedSuccess({ isMenuPinned }));
    } else {
      Logger.log('EXPAND_NAVIGATION_LOGIN failed');
    }
  } catch (error) {
    Logger.log('EXPAND_NAVIGATION_LOGIN failed', error);
  }
}

export default function* loginSaga() {
  yield takeLatest(loginRequestActionType, userInfoSaga);
  yield takeLatest(userModulesActionType, userModulesSaga);
  // yield takeLatest(loginInfoActionType, loginInfoSaga);
  yield takeLatest(userDetailsActionType, fetchUserDetails);
  yield takeLatest(APP_CONSTANTS_ACTION, fetchAppConstants);
  yield takeLatest(APP_MESSAGES, fetchAppMessages);
  yield takeLatest(GET_HEADER_MENU, fetchHeaderMenu);
  yield takeLatest(UPDATE_EMAIL_LANGUAGE, updateEmailAndLanguage);
  yield takeLatest(FETCH_THEME_CONFIG_LIST, fetchThemeConfigSaga);
  yield takeLatest(GET_INITIAL_DATA_ACTION, fetchInitialDataSaga);
  yield takeLatest(FETCH_ECM_VERSION, requestEcmVersionSaga);
  yield takeLatest(GET_ACTIVE_THEME, getActiveThemeSaga);
  yield takeLatest(GET_ACTIVE_LOGO, getActiveLogoSaga);
  yield takeLatest(GET_ACTIVE_FAVICON, getActiveFavIconSaga);
  yield takeLatest(GET_ACTIVE_HEADER_LOGO, getActiveHeaderLogoSaga);
  yield takeLatest(CONSOLIDATED_CONFIG_ACTION, getConsolidatedConfigSaga);
}
